import { compose } from '@reduxjs/toolkit';

export const extraReducers = compose();
